import { render } from "./one_chat.html?vue&type=template&id=77ffe20e&external"
import script from "./one_chat.js?vue&type=script&lang=js&external"
export * from "./one_chat.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__